<template>
  <div>
    <div class="text-center">
      <div class="module-container">
        <template v-for="(type, index) in types">
          <v-menu
            :key="index"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <button
                class="select-module-btn"
                :id="'module-type-' + type.id"
                @click="onClickTypeSelected(type)"
                v-bind="attrs"
                v-on="on"
              >
                {{ type.name }}
              </button>
            </template>
            <v-list
              class="module-menu"
            >
              <v-list-item
                v-for="schoolLevel in listSchoolLevelByType" :key="'sl' + schoolLevel.id"
                :id="'module-' + type.id + '-school-level-' + schoolLevel.id"
                @click="changeModule(schoolLevel.id, type.id)"
              >
                <v-list-item-title>
                  {{ schoolLevel.name }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </div>
    </div>
    <div class="action-form-container">
      <div>
        <v-select
          class="filter-store-btn"
          v-model="filterForm.store"
          :items="contactStatusStore"
          item-text="text"
          item-value="value"
          dense
          outlined
          hide-details
          @change="searchContactStatus()"
        />
      </div>
      <div>
          <button
              class="create-status-btn"
              @click="addContactStatus"
          >
              Thêm MQH
              <v-icon class="mb-1">mdi-plus</v-icon>
          </button>
      </div>
    </div>
  </div>
</template>
<script>
  import { contactStatusTOptionsView } from '../../../helpers/constants'
  import { contactStatusCOptionsView } from '../../../helpers/constants'
  import { contactStatusGOptionsView } from '../../../helpers/constants'
  import { contactStatusMOptionsView } from '../../../helpers/constants'
  import { contactStatusStore } from '../../../helpers/constants'
  export default {
    name: 'ContactStatusFilterForm',
    props: {
      filterForm: {
        type: Object,
        default: () => {}
      },
      schoolLevels: {
        type: Array,
        default: () => {[]}
      },
      types: {
        type: Array,
        default: () => {[]}
      }
    },

    data () {
      return {
        contactStatusTOptionsView,
        contactStatusCOptionsView,
        contactStatusGOptionsView,
        contactStatusMOptionsView,
        contactStatusStore,
        typeIdSelected: 1,
        openMenu: false
      }
    },

    watch: {
      filterForm: {
        deep: true,
        handler(newVal, oldVal) {
          if (newVal.schoolLevelId != oldVal.schoolLevelId
            || newVal.typeId != oldVal.typeId) {
            this.activeModule(newVal)
          }
        }
      }
    },

    updated() {
      this.activeModule(this.filterForm)
    },
    computed: {
      listSchoolLevelByType() {
        if(this.schoolLevels.length > 0 && this.typeIdSelected){
            const result = this.schoolLevels.find(school => this.typeIdSelected === school.id)
            return  result.schoolLevel || []
        } else return []
      }
    },

    methods: {
      onClickTypeSelected(type){
        this.typeIdSelected = type.id
      },
      searchContactStatus () {
        Bus.$emit('contact-status-list-filter', this.filterForm)
      },

      addContactStatus () {
        Bus.$emit('show-contact-status-form-modal', { store: this.filterForm.store })
      },

      changeModule(schoolLevelId, typeId) {
        Bus.$emit('contact-status-list-filter', {
          ...this.filterForm,
          schoolLevelId,
          typeId
        })
      },

      activeModule(newVal) {
        let oldTypes = document.getElementsByClassName('select-module-btn active')

        if (oldTypes.length) {
          oldTypes[0].classList.remove('active')
        }

        let oldSchoolLevels = document.getElementsByClassName('v-list-item active')

        if (oldSchoolLevels.length) {
          oldSchoolLevels[0].classList.remove('active')
        }

        let newType = document.getElementById('module-type-' + newVal.typeId)

        if (newType) {
          newType.classList.add('active')
        }

        let newSchoolLevel = document.getElementById('module-' + newVal.typeId + '-school-level-' + newVal.schoolLevelId)

        if (newSchoolLevel) {
          newSchoolLevel.classList.add('active')
        }
      }
    },
  }
</script>

<style scoped>
.select-module-btn {
  padding: 5px 20px;
  border: 8px solid #D7D3F2;
  border-left: 1px solid #D7D3F2;
  border-right: 1px solid #D7D3F2;
  font-size: 16px;
  font-weight: 400;
}

.select-module-btn:first-child {
  box-shadow: -5px 0px 0px 8px #d7d3f2;
  border: none;
  border-radius: 10px 0px 0px 10px;
}

.select-module-btn:last-child {
  box-shadow: 5px 0px 0px 8px #d7d3f2;
  border: none;
  border-radius: 0px 10px 10px 0px;
}

.select-module-btn.active {
  background: #7E75DD;
  color: white;
}

.action-form-container {
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
}

.create-status-btn {
  padding: 5px 8px;
  border: 1px solid black;
  font-size: 16px;
  font-weight: 400;
  border-radius: 8px;
  outline: unset;
}

/deep/ .module-menu.v-list {
  background: #D7D3F2;
}

/deep/ .module-menu.v-list .v-list-item {
  cursor: pointer;
}

/deep/ .module-menu.v-list .v-list-item .v-list-item__title {
  color: black;
  font-size: 16px;
}

/deep/ .module-menu.v-list .v-list-item:hover {
  background: #cdc7f5;
}

/deep/ .module-menu.v-list .v-list-item.active {
  background: #7E75DD;
}

/deep/ .module-menu.v-list .v-list-item.active .v-list-item__title {
  color: white;
}

/deep/ .filter-store-btn.v-text-field {
  border: 1px solid black;
  border-radius: 8px;
  width: 120px;
}

/deep/ .filter-store-btn.v-select .v-select__selections {
  font-size: 16px;
  font-weight: 400;
  padding: 0px !important;
}

/deep/ .filter-store-btn.v-select .v-input__control .v-input__slot {
  min-height: fit-content !important;
}

/deep/ .filter-store-btn.v-select.v-text-field--outlined fieldset {
  border: unset;
}

/deep/ .filter-store-btn.v-select .v-input__append-inner {
  margin-top: 5px !important;
}

/deep/ .filter-store-btn.v-select .v-input__append-inner .v-icon.primary--text {
  color: black !important;
}
</style>